import { render } from "./social-authentication.vue?vue&type=template&id=990f4888"
import script from "./social-authentication.vue?vue&type=script&lang=js"
export * from "./social-authentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__